import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { ViewType } from '@/entities/session';
import { selectViewsRestrictions, ViewAccessType } from '@/entities/session';
import { ROUTES } from '@/shared/constants';
import { useAppSelector } from '@/shared/model';

interface Props {
  view: ViewType;
  children: ReactNode;
}

export function ViewsRestrictionsGuard({ view, children }: Props) {
  const viewsRestrictions = useAppSelector(selectViewsRestrictions);

  if (viewsRestrictions?.[view] === ViewAccessType.DENIED) {
    return <Navigate to={ROUTES.home} />;
  }

  return children;
}
